import { ref, watchEffect } from 'vue'

const isDark = ref(localStorage.getItem('neogo_theme') === 'dark')

export function useTheme() {
  watchEffect(() => {
    if (isDark.value) {
      document.documentElement.classList.add('dark-mode')
      localStorage.setItem('neogo_theme', 'dark')
    } else {
      document.documentElement.classList.remove('dark-mode')
      localStorage.setItem('neogo_theme', 'light')
    }
  })

  function toggle() {
    isDark.value = !isDark.value
  }

  return { isDark, toggle }
}
